import { useCallback, useContext } from 'react'
import makePath from 'app/Utils/url.util'
import CountryLangCtx from 'app/contexts/countryLang/CountryLangCtx'

export default function usePrependPath () {
  const { country, language } = useContext(CountryLangCtx)
  const prependPath = useCallback((v = '') => `${makePath(country, language)}${v ? `/${v}` : ''}`, [country, language])
  return prependPath
}
